import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { CmpCtx } from '../App.jsx';
import { MOCK_PROPERTIES } from '../api/mock.js';
import { adapt } from '../api/client.js';
import Img from '../components/ui/Img.jsx';
import { PROP_TYPES } from '../data/constants.js';

const ROWS = [
  ['Precio',       p => (p.currency==='USD'?'US$ ':'$ ') + p.price.toLocaleString('es-AR') + (p.operationType==='alquiler'?'/mes':''), true],
  ['Tipo',         p => PROP_TYPES[p.type]||p.type],
  ['Zona',         p => p.neighborhood],
  ['Ambientes',    p => p.rooms||'—'],
  ['Dormitorios',  p => p.bedrooms||'—'],
  ['Baños',        p => p.bathrooms||'—'],
  ['m² cubiertos', p => p.coveredArea||'—'],
  ['m² totales',   p => p.totalArea||'—'],
  ['Cocheras',     p => p.parkingSpaces||'—'],
  ['Expensas',     p => p.expenses?'$ '+p.expenses.toLocaleString('es-AR'):'—'],
  ['Apto crédito', p => p.creditEligible?'Sí':'No'],
];

export default function Compare() {
  const { cmp, toggleCmp } = useContext(CmpCtx);
  const list = MOCK_PROPERTIES.map(adapt).filter(p => cmp.includes(p.id));
  if (list.length === 0) return (
    <div className="container page">
      <div className="page-head"><span className="kicker">Lado a lado</span><h1 className="page-h1">Comparador</h1></div>
      <div className="empty"><div className="empty-ic">⇄</div><h3>No hay propiedades para comparar</h3><p>Agregá hasta 4 propiedades desde el listado.</p><Link className="btn btn-primary" to="/buscar?op=venta">Buscar propiedades</Link></div>
    </div>
  );
  return (
    <div className="container page">
      <div className="page-head"><span className="kicker">Lado a lado</span><h1 className="page-h1">Comparador</h1><p className="page-sub">Hasta 4 propiedades, las diferencias que importan a la vista.</p></div>
      <div className="cmp-scroll">
        <table className="cmp-table">
          <thead><tr>
            <th className="cmp-corner" />
            {list.map(p => (
              <th key={p.id} className="cmp-ph">
                <div className="cmp-card">
                  <Img src={p.images[0]?.full} alt={p.title} ratio="4/3" className="cmp-img" />
                  <button className="cmp-rm" onClick={() => toggleCmp(p.id)} aria-label="Quitar">✕</button>
                  <div className="cmp-name">{p.title}</div>
                  <Link className="btn btn-ghost btn-sm cmp-view" to={"/propiedad/"+p.slug}>Ver ficha</Link>
                </div>
              </th>
            ))}
          </tr></thead>
          <tbody>
            {ROWS.map(([label, fn, hl]) => (
              <tr key={label} className={hl ? 'cmp-hl' : ''}>
                <td className="cmp-label">{label}</td>
                {list.map(p => <td key={p.id} className="cmp-val">{fn(p)}</td>)}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
